import React, { useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button'
import { ToggleButtonGroup , ToggleButton } from '@material-ui/lab';
import useToken from '../../useToken';
import { useSelector, useDispatch } from 'react-redux';
import { useAuth } from '../../contexts/AuthContext';
import { fetchEnvironment } from '../../features/environment/environmentSlice';
import EnvironmentTable from './EnvironmentTable';
import Chart from './Chart';
import * as CsvExporter from '../../CsvExporter';
import { CSVLink } from "react-csv";
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import {  MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { subDays } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";

const theme = createTheme({
  palette: {
    primary: { main: "#657a71", contrastText: "#fff" },
  },
});

const useStyles = makeStyles ({
      root: {
              display: 'flex',
            },
      toolbar: {
              paddingRight: 24, // keep right padding when drawer closed
            },
      toolbarIcon: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              padding: '0 8px',
            },
      menuButton: {
              marginRight: 36,
            },
      menuButtonHidden: {
              display: 'none',
            },
      title: {
              flexGrow: 1,
            },
      content: {
              flexGrow: 1,
              height: '100vh',
              overflow: 'auto',
            },
      container: {
              paddingTop: 1,
              paddingBottom: 1,
            },
      paper: {
              display: 'flex',
              flexDirection: 'column',
            },
      fixedHeight: {
              height: 400,
            },
      link: {
              textDecoration: 'none', 
              color: "#657a71",
              marginRight: 20,
              margin:10,
              border:1 ,  
            }
});

const Environment = () => {
  const [section, setSection] = React.useState('A')
  const [period, setPeriod] = React.useState('today')
  const [selection, setSelection] = React.useState('air_temperature')
  const [selectedFromDate, setSelectedFromDate] = React.useState(
    subDays(new Date(), 1));
  const [selectedToDate, setSelectedToDate] = React.useState(
    new Date()
  );
  const [disableCustom, setDisableCustom] = React.useState(true)

  const {token, setToken} = useToken()
  const { logout } = useAuth()
  const dispatch = useDispatch()
  const environment = useSelector((state: any) => state.environment.environmentData)

  if (environment.error === "unauthorized") {
      logout()
      window.location.reload();
  }

    useEffect(() => {
      dispatch(fetchEnvironment({token, section, period, selection}))
    }, [dispatch]);

    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    
    const handleSection = (event, newSection) => {
      if (newSection !== null) {
        setSection(newSection)
        const section = newSection
        dispatch(fetchEnvironment({token, section, period, selection}))
      }
    }

    const handlePeriod = (event, newPeriod) => {
      if (newPeriod != null) {
        if (newPeriod === "custom") {
          setDisableCustom(false)
          setPeriod(newPeriod)
          const period = newPeriod
          dispatch(fetchEnvironment({token, section, period, selection, 
            selectedFromDate ,selectedToDate}))
        } else {
          setDisableCustom(true)
          setPeriod(newPeriod)
          const period = newPeriod
          dispatch(fetchEnvironment({token, section, period, selection}))
        }
      }
    }

    const handleSelection = (event, newSelection) => {
      if (newSelection != null) {
        setSelection(newSelection)
        const selection = newSelection
        dispatch(fetchEnvironment({token, section, period, selection}))
      }
    }

    const handleSelectFrom = (newFromDate) => {
      if (newFromDate < selectedToDate) {
        setSelectedFromDate(newFromDate)
        const selectedFromDate = newFromDate
        dispatch(fetchEnvironment({token, section, period, selection, 
          selectedFromDate ,selectedToDate}))
      } else {
        alert("From date is newer than To date.")
      }
    }

    const handleSelectTo = (newToDate) => {
      if (newToDate > selectedFromDate) { 
        setSelectedToDate(newToDate)
        const selectedToDate = newToDate
        dispatch(fetchEnvironment({token, section, period, selection, 
          selectedFromDate ,selectedToDate}))
      }else {
        alert("To date is older than From date.")
      }
    }

    const exportCSV = CsvExporter.getEnvironment({environments: environment.data.Data})
    
    if (environment.status === "idle") { 
        return (
         <Container maxWidth="lg" className={classes.container}>
         <h1>Environment</h1>

        <Grid container>
         <Grid item xs={12}>
         <ToggleButtonGroup
         value={section}
         exclusive
         onChange={handleSection}
         section-label="Section A"
         >
         <ToggleButton value="A" section-label="Section A">
          Section A
         </ToggleButton>
         <ToggleButton value="B" section-label="Section B">
          Section B
         </ToggleButton>
         <ToggleButton value="C" section-label="Section C">
          Section C
         </ToggleButton>
          <ToggleButton value="D" section-label="Section D">
          Section D
         </ToggleButton>
         </ToggleButtonGroup>
         </Grid>
         </Grid>

         <hr/>

         <Grid container>
         <Grid item xs={4}>
         <ToggleButtonGroup
         value={period}
         exclusive
         onChange={handlePeriod}
         period-label="today"
         >
         <ToggleButton value="today" period-label="today">
         Today
         </ToggleButton>
         <ToggleButton value="week" period-label="week">
         7 Days
         </ToggleButton>
         <ToggleButton value="month" period-label="month">
         30 Days
         </ToggleButton>
         <ToggleButton value="custom" period-label="custom">
         Custom
         </ToggleButton>
         </ToggleButtonGroup>
         </Grid>

          <Grid item xs={8} spacing={10}>
         <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <ThemeProvider theme={theme}>
        <DatePicker
          variant="inline"
          label="From"
          format="yyyy-MM-dd"
          value={selectedFromDate}
          disabled={disableCustom}
          onChange={handleSelectFrom}
        />  
        </ThemeProvider>
        </MuiPickersUtilsProvider>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <ThemeProvider theme={theme}>
        <DatePicker
          variant="inline"
          label="To"
          format="yyyy-MM-dd"
          value={selectedToDate}
          disabled={disableCustom}
          onChange={handleSelectTo}
        />
        </ThemeProvider>  
        </MuiPickersUtilsProvider>
         </Grid>
        
        </Grid>
         <br/>

         <Grid container>
         <Grid item xs={12}>
         <ToggleButtonGroup
         value={selection}
         exclusive
         onChange={handleSelection}
         selection-label="Air Temperature"
         >
         <ToggleButton value="air_temperature" selection-label="air_temperature">
         Air Temperature
         </ToggleButton>
         <ToggleButton value="air_humidity" period-label="air_humidity">
         Air Humidity
         </ToggleButton>
         <ToggleButton value="soil_temperature" period-label="soil_temperature">
         Soil Temperature
         </ToggleButton>
         <ToggleButton value="soil_ec" period-label="soil_ec">
         Soil EC
         </ToggleButton>
          <ToggleButton value="soil_humidity" period-label="soil_humidity">
         Soil Humidity
         </ToggleButton>
         <ToggleButton value="illuminance" period-label="illuminance">
         Illuminance
         </ToggleButton>
         </ToggleButtonGroup>
         </Grid>
         </Grid>

         <br/>

         <Grid container>
         <Grid item xs={12}>
         <Paper className={fixedHeightPaper}>
         <Chart data={environment.data.Chart} />
         </Paper>
         </Grid>
         </Grid>
         <br/>
         <Grid container>
         <Grid item xs={12}>
         <Paper className={fixedHeightPaper}>
         <Grid container justifyContent="flex-end">
            <CSVLink className={classes.link} 
              filename={exportCSV.filename}
              headers={exportCSV.header}
              data={exportCSV.data}>
              <Button variant="outlined">Export CSV</Button>
            </CSVLink>
         </Grid>
         <EnvironmentTable data={environment.data.Data} />
         </Paper>
         </Grid>
         </Grid>
         <Box pt={4}>
         </Box>
         </Container>
        )
    } else {
      return (<h3> loading </h3>)
    }
  }

export default Environment
